export default __webpack_public_path__ + "static/media/what.31d4b1d2.png";